import { render, staticRenderFns } from "./relevance-form-modal.vue?vue&type=template&id=3271a3c2&scoped=true&"
import script from "./relevance-form-modal.vue?vue&type=script&lang=ts&"
export * from "./relevance-form-modal.vue?vue&type=script&lang=ts&"
import style0 from "./relevance-form-modal.vue?vue&type=style&index=0&id=3271a3c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3271a3c2",
  null
  
)

export default component.exports